import { useEffect, useState } from "react";
import { Loader2, CheckCircle2, XCircle, ShieldAlert, RefreshCcw } from "lucide-react";
import client, { getAdminToken } from "@/lib/api";

export default function ReadinessPanel() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const r = await client.get("/admin/readiness", { headers: { "X-Admin-Token": getAdminToken() || "" } });
      setData(r.data);
    } finally { setBusy(false); }
  };
  useEffect(() => { load(); }, []);

  const ready = data?.requiredPassing;
  const sendReady = data?.sendReadyForProduction;

  return (
    <section className="mb-6 rounded-3xl border p-6" style={{
      borderColor: sendReady ? "var(--ta-success)" : "#B04635",
      background: sendReady ? "var(--ta-success-bg)" : "#FDECEA",
    }} data-testid="readiness-panel">
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="flex items-start gap-3">
          <div className="w-11 h-11 rounded-2xl inline-flex items-center justify-center shrink-0"
            style={{ background: sendReady ? "var(--ta-success)" : "#B04635", color: "#fff" }}>
            {sendReady ? <CheckCircle2 size={22} /> : <ShieldAlert size={22} />}
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest font-semibold" style={{ color: sendReady ? "var(--ta-success)" : "#B04635" }}>
              Email Delivery Readiness
            </div>
            <h2 className="font-display text-xl font-semibold mt-0.5" style={{ color: "var(--ta-primary)" }}>
              {sendReady ? "Ready for production." : "Email delivery is not ready for production."}
            </h2>
            <p className="mt-1 text-sm" style={{ color: "var(--ta-text-secondary)" }}>
              {ready
                ? "All required checks pass. Set EMAIL_SEND_ENABLED=true to go live."
                : "Complete every checklist item below before enabling customer sending."}
            </p>
          </div>
        </div>
        <button onClick={load} disabled={busy} data-testid="readiness-refresh"
          className="inline-flex items-center gap-1 h-9 px-3 rounded-full text-xs font-medium border-2"
          style={{ borderColor: "var(--ta-border)", background: "#fff", color: "var(--ta-primary)" }}>
          {busy ? <Loader2 size={14} className="animate-spin" /> : <RefreshCcw size={14} />} Run readiness check
        </button>
      </div>

      {data && (
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-2" data-testid="readiness-checks">
          {data.checks.map((c) => (
            <li key={c.id} className="flex items-start gap-2 p-3 rounded-xl" style={{ background: "#fff" }} data-testid={`readiness-check-${c.id}`}>
              {c.ok ? <CheckCircle2 size={18} style={{ color: "var(--ta-success)" }} />
                    : <XCircle size={18} style={{ color: "#B04635" }} />}
              <div className="flex-1 text-sm">
                <div className="font-medium" style={{ color: "var(--ta-primary)" }}>{c.label}</div>
                {!c.ok && c.detail && <div className="text-xs mt-0.5" style={{ color: "#B04635" }}>{c.detail}</div>}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
